import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowIncomeBankAccountItem } from '../types/cashFlowIncomeBankAccount'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowIncomeBankAccount: builder.query<CashFlowIncomeBankAccountItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeBankAccount/${data.id}`,
      }),
    }),
    changeCashFlowIncomeBankAccount: builder.mutation<void, PayloadRequest & CashFlowIncomeBankAccountItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeBankAccount/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowIncomeBankAccount: builder.mutation<void, CashFlowIncomeBankAccountItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeBankAccount`,
        method: 'POST',
        body: data
      }),
    }),
  }),
})

export const {
  useChangeCashFlowIncomeBankAccountMutation,
  useCreateCashFlowIncomeBankAccountMutation,
  useGetCashFlowIncomeBankAccountQuery,
  useLazyGetCashFlowIncomeBankAccountQuery
} =
cashFlowSchemas
